import { Action } from '@/_core/fluxstore/types';
import { AccountState } from '../types';
import { useAccountStore } from '../useModule';
import { AccountQueryResult } from '@/api/account/queries';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

const { registerReducer } = useAccountStore();

export class InitAccount extends Action<AccountState> {
    public static ACTION_TYPE = 'InitAccount';

    public constructor(public accountQueryResult: AccountQueryResult) {
        super(InitAccount.ACTION_TYPE);
    }
}

const reducer = (state: AccountState, action: InitAccount): void => {
    const tmp = mapKeys(action.accountQueryResult, (v, key) => camelCase(key));
    state = Object.assign(state, tmp);

    state.isInitialized = true;

    //state.name = action.accountQueryResult.Name;
};

//@ts-ignore
registerReducer(InitAccount.ACTION_TYPE, reducer);
